import { isOpenAdminOrderStatusModal } from "@/atoms/order/is-open-admin-order-status-modal";
import {
  OrderStatus,
  OrderStatusDisplayNames,
} from "@/common/enum/order-status";
import {
  PaymentStatus,
  paymentStatusDisplayNames,
} from "@/common/enum/payment-status";
import { PaymentType } from "@/common/enum/payment-type";
import { Body14Regular } from "@/components/typography/Body14Regular";
import { Body14Underline } from "@/components/typography/Body14Underline";
import { OrderDetailDto } from "@/types/dto/order-detail-dto";
import { Table } from "flowbite-react";
import { useRecoilState } from "recoil";
import { CustomCell } from "../CustomCell";

interface Props {
  orderDetail: OrderDetailDto;
  openPartnerInfoModal: () => void;
}

export const AdminOrderDetailOrdererTable: React.FC<Props> = ({
  orderDetail,
  openPartnerInfoModal,
}) => {
  const [_, setisAdminOrderStatusModalOpen] = useRecoilState(
    isOpenAdminOrderStatusModal,
  );

  const headCellStyle = "font-medium text-gray-900 bg-gray-100";
  const paymentStatus = orderDetail.payment.status;
  const isPayLater = orderDetail.payment.paymentMethod === PaymentType.PALT;
  const isTaxProcessed = orderDetail.status === OrderStatus.TAX_PROCESSED;

  const handleOrderStatusClick = () => {
    setisAdminOrderStatusModalOpen(true);
  };

  return (
    <div className="overflow-x-auto flex flex-col gap-[16px]">
      <div className="rounded-lg border overflow-hidden">
        <Table>
          <Table.Body>
            <Table.Row className="border-b border-gray-200">
              <Table.Cell className={`${headCellStyle} w-[112px] p-0 h-[52px]`}>
                <CustomCell>
                  <Body14Regular className="text-semantic-text-secondary">
                    파트너명
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell
                className="w-[680px] bg-primary-white border-l cursor-pointer"
                onClick={openPartnerInfoModal}
              >
                <CustomCell>
                  <Body14Underline className="text-semantic-text-body">
                    {orderDetail.ordererName}
                  </Body14Underline>
                </CustomCell>
              </Table.Cell>
              <Table.Cell
                className={`${headCellStyle} w-[112px] p-0 h-[52px] border-l`}
              >
                <CustomCell>
                  <Body14Regular className="text-semantic-text-secondary">
                    상호명
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell className="w-[680px] h-[52px] bg-primary-white border-l">
                <CustomCell>
                  <Body14Regular className="text-semantic-text-body">
                    {orderDetail.ordererBusinessName}
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
            </Table.Row>
            <Table.Row className="border-b border-gray-200">
              <Table.Cell className={`${headCellStyle} w-[112px] p-0 h-[52px]`}>
                <CustomCell>
                  <Body14Regular className="text-semantic-text-secondary">
                    결제 상태
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell className="w-[680px] bg-primary-white border-l">
                <CustomCell>
                  {isPayLater && isTaxProcessed ? (
                    <Body14Regular
                      className={"text-semantic-text-error-primary"}
                    >
                      세금계산서 발행 완료
                    </Body14Regular>
                  ) : (
                    <Body14Regular
                      className={
                        paymentStatus === PaymentStatus.PENDING
                          ? "text-semantic-text-error-primary"
                          : "text-semantic-text-body"
                      }
                    >
                      {paymentStatusDisplayNames[paymentStatus]}
                    </Body14Regular>
                  )}
                </CustomCell>
              </Table.Cell>
              <Table.Cell
                className={`${headCellStyle} w-[112px] p-0 h-[52px] border-l`}
              >
                <CustomCell>
                  <Body14Regular className="text-semantic-text-secondary">
                    발주 상태
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell className="w-[680px] bg-primary-white border-l">
                <CustomCell>
                  <div onClick={handleOrderStatusClick}>
                    <Body14Underline className="text-semantic-text-body">
                      {OrderStatusDisplayNames[orderDetail.status]}
                    </Body14Underline>
                  </div>
                </CustomCell>
              </Table.Cell>
            </Table.Row>
            <Table.Row className=" border-gray-200">
              <Table.Cell className={`${headCellStyle} w-[112px] p-0 h-[52px]`}>
                <CustomCell>
                  <Body14Regular className="text-semantic-text-secondary">
                    공사명
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell className="w-[680px] bg-primary-white border-l">
                <CustomCell>
                  <Body14Regular className="text-semantic-text-body">
                    {orderDetail.constructionName}
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell
                className={`${headCellStyle} w-[112px] p-0 h-[52px] border-l`}
              >
                <CustomCell>
                  <Body14Regular className="text-semantic-text-secondary">
                    공종명
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell className="w-[680px] bg-primary-white border-l">
                <CustomCell>
                  <Body14Regular className="text-semantic-text-body">
                    {orderDetail.constructionWorkName}
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </div>
    </div>
  );
};
